import React, { useState, useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./Resume.css";

const Resume = (props) => {
  /* STATES */
  const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
  const [carousalOffsetStyle, setCarousalOffsetStyle] = useState({});

  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  /* REUSABLE MINOR COMPONENTS */
  const ResumeHeading = (props) => {
    return (
      <div className="resume-heading">
        <div className="resume-main-heading">
          <div className="heading-bullet"></div>
          <span>{props.heading ? props.heading : ""}</span>
          {props.fromDate && props.toDate ? (
            <div className="heading-date">
              {props.fromDate + "-" + props.toDate}
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div className="resume-sub-heading">
          <span>{props.subHeading ? props.subHeading : ""}</span>
        </div>
        <div className="resume-heading-description">
          <span>{props.description ? props.description : ""}</span>
        </div>
      </div>
    );
  };

  /* STATIC RESUME DATA FOR THE LABELS*/
  const resumeBullets = [
    { label: "Education", logoSrc: "education.svg" },
    { label: "Work History", logoSrc: "work-history.svg" },
    { label: "Programming Skills", logoSrc: "programming-skills.svg" },
    { label: "Projects", logoSrc: "projects.svg" },
    { label: "Interests", logoSrc: "interests.svg" },
  ];

  //here we have
  const programmingSkillsDetails = [
    { skill: "Core Java", ratingPercentage: 89 },
    { skill: "J2EE", ratingPercentage: 86 },
    { skill: "Python", ratingPercentage: 70 },
    { skill: "DBMS", ratingPercentage: 89 },
    { skill: "MySQL", ratingPercentage: 75 },
    { skill: "JavaScript", ratingPercentage: 85 },
    { skill: "Angular", ratingPercentage: 85 },
    { skill: "HTML", ratingPercentage: 85 },
    { skill: "CSS", ratingPercentage: 80 },
    { skill: "Bootstrap", ratingPercentage: 89 },
  ];

  const projectsDetails = [
    {
      title: "Personal Portfolio Website",
      duration: { fromDate: "2024", toDate: "2024" },
      description:
        "A Personal Portfolio website to showcase all my details and projects at one place.",
      subHeading: "Technologies Used: React JS, Bootsrap",
    },
    {
      title: "Quiz Portal ",
      duration: { fromDate: "2020", toDate: "2021" },
      description:
        "An interactive online quiz portal designed for users to test and enhance their knowledge across various subjects. Features include user authentication, real-time quiz results, leaderboards, and diverse question categories.",
      subHeading:
        "Technologies Used:  Java, Spring Boot, MySQL, Angular.",
    },
    {
      title: "PG Rental System ",
      duration: { fromDate: "2020", toDate: "2021" },
      description:
        "A streamlined platform for managing rental properties and tenants, featuring property listings, tenant management, rent tracking, maintenance requests, and secure payment integration.",
      subHeading:
        "Technologies Used:  Java, Spring Boot, MySQL, Angular.",
    },

  ];

  const resumeDetails = [
    <div className="resume-screen-container" key="education">

      <ResumeHeading
        heading={"Government Engineering College Aurangabad, Chha. Sambhajinagar"}
        subHeading={"MASTERS IN COMPUTER APPLICATION    -"}
        fromDate={"2023"}
        toDate={"2025"}
      />

      <ResumeHeading
        heading={"Shivaji Art's Commerce and Science College, Kannad"}
        subHeading={"BACHELOR OF COMPUTER SCIENCE    77%"}
        fromDate={"2019"}
        toDate={"2022"}
      />

      <ResumeHeading
        heading={"Dr. Bhimrao Ambedkar Jr. College, Kannad"}
        subHeading={"HSC (12 th)    47%"}
        fromDate={"2017"}
        toDate={"2019"}
      />
      <ResumeHeading
        heading={"Savitribai Fule High School, Kannad"}
        subHeading={"SSC (10 th)    71%"}
        fromDate={"2016"}
        toDate={"2017"}
      />
    </div>,

    /* WORK EXPERIENCE */
    <div className="resume-screen-container" key="work-experience">

      <div className="experience-container">
        <ResumeHeading
          heading={"Vizpay Business Solutions"}
          subHeading={"Software Developer"}
          fromDate={"Dec-22"}
          toDate={"Present"}
        />
        <div className="experience-description">
          <span className="resume-description-text">
            Worked as a Software Developer, contributing to full-stack development and deployment efforts.
          </span>
        </div>
        <div className="experience-description">
          <span className="resume-description-text">
            - Developed a billing and inventory management application across web and Android platforms.
          </span>
          <br />
          <span className="resume-description-text">
            - Built a responsive Android app using Flutter.
          </span>
          <br />
          <span className="resume-description-text">
            - Developed a robust backend using Spring Boot, focusing on scalable RESTful APIs and secure data handling.
          </span>
          <br />
          <span className="resume-description-text">
            - Created a dynamic and intuitive portal using Angular 19 for efficient business operations.
          </span>
          <br />
          <span className="resume-description-text">
            - Implemented CI/CD pipelines to streamline backend and portal deployment processes.
          </span>
        </div>
      </div>
    </div>,



    /* PROGRAMMING SKILLS */
    <div
      className="resume-screen-container programming-skills-container"
      key="programming-skills"
    >
      {programmingSkillsDetails.map((skill, index) => (
        <div className="skill-parent" key={index}>
          <div className="heading-bullet"></div>
          <span>{skill.skill}</span>
          <div className="skill-percentage">
            <div
              style={{ width: skill.ratingPercentage + "%" }}
              className="active-percentage-bar"
            ></div>
          </div>
        </div>
      ))}
    </div>,

    /* PROJECTS */
    <div className="resume-screen-container" key="projects">
      {projectsDetails.map((projectsDetails, index) => (
        <ResumeHeading
          key={index}
          heading={projectsDetails.title}
          subHeading={projectsDetails.subHeading}
          description={projectsDetails.description}
          fromDate={projectsDetails.duration.fromDate}
          toDate={projectsDetails.duration.toDate}
        />
      ))}
    </div>,

    /* Interests */
    <div className="resume-screen-container" key="interests">

      <ResumeHeading
        heading="Tech Blogging"
        description="Sharing insights through tech blogging or creating tutorials demonstrates strong communication skills and establishes thought leadership within the tech community."
      />

      <ResumeHeading
        heading="Trekking"
        description="Apart from being a dedicated tech enthusiast and proficient code writer, I also find joy in trekking, embodying resilience, adventure, and a holistic approach to life."
      />
      <ResumeHeading
        heading="Music"
        description="Listening to soothing music is something i can never compromise with, skimming through Spotify's pop songs charts is at times the best stress reliever that i can get my hands on."
      />

    </div>,
  ];

  const handleCarousal = (index) => {
    let offsetHeight = 360;

    let newCarousalOffset = {
      style: { transform: "translateY(" + index * offsetHeight * -1 + "px)" },
    };

    setCarousalOffsetStyle(newCarousalOffset);
    setSelectedBulletIndex(index);
  };

  const getBullets = () => {
    return resumeBullets.map((bullet, index) => (
      <div
        onClick={() => handleCarousal(index)}
        className={
          index === selectedBulletIndex ? "bullet selected-bullet" : "bullet"
        }
        key={index}
      >
        <img
          className="bullet-logo"
          src={require(`../../assets/Resume/${bullet.logoSrc}`)}
          alt="B"
        />
        <span className="bullet-label">{bullet.label}</span>
      </div>
    ));
  };

  const getResumeScreens = () => {
    return (
      <div
        style={carousalOffsetStyle.style}
        className="resume-details-carousal"
      >
        {resumeDetails.map((ResumeDetail) => ResumeDetail)}
      </div>
    );
  };

  useEffect(() => {
    return () => {
      /* UNSUBSCRIBE THE SUBSCRIPTIONS */
      fadeInSubscription.unsubscribe();
    };
  }, [fadeInSubscription]);

  return (
    <div
      className="resume-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="resume-content">
        <ScreenHeading title={"Resume"} subHeading={"My formal Bio Details"} />
        <div className="resume-card">
          <div className="resume-bullets">
            <div className="bullet-container">
              <div className="bullet-icons"></div>
              <div className="bullets">{getBullets()}</div>
            </div>
          </div>

          <div className="resume-bullet-details">{getResumeScreens()}</div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
